const isValueEqualCaseInsensitive = (valueA, valueB) => String(valueA).toLowerCase() === String(valueB).toLowerCase();
const autocompleteTokensEqual = (tokenA, tokenB) => tokenA.name === tokenB.name
    && isValueEqualCaseInsensitive(tokenA.value, tokenB.value);
export default autocompleteTokensEqual;
